import * as React from 'react';
import * as d3 from 'd3';
import PieChart from './PieChart';
import { Box } from '@mui/material';

import * as svg from 'save-svg-as-png';

const COLORS = ["#e0ac2b", "#e85252", "#6689c6", "#9a6fb0", "#a53253"];

const PieGroupChart = React.forwardRef(({ width, color: defaultColor, data }, ref) => {
  const allGroups = data.map((group) => group.group);
  const color = defaultColor.length === 0 ? ["#e0ac2b"] : defaultColor;
  // const colorScale = d3.scaleOrdinal().domain(allGroups).range(color);

  const maxPerGroup = data.map((group) => Math.max(...group.values.map(v => v.value)));
  const max = Math.max(...maxPerGroup);

  const numberOfColumn = 1;

  React.useImperativeHandle(ref, () => ({
    saveAsImage
  }));

  const saveAsImage = () => {
    const svgElements = document.getElementById("chartPanel").getElementsByTagName("svg");
    Array.from(svgElements).forEach((element, index) => {
      svg.saveSvgAsPng(element, `chart-${index}.png`)
    })
  }

  return (
    <Box
      sx={{
        width,
        display: 'grid',
        // gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      }}
      id="chartPanel"
    >
      {data.map((group, i) => (
        <PieChart
          key={i}
          width={width / numberOfColumn}
          height={300}
          color={color}
          xRange={[0, max]}
          data={group.values}
        />
      ))}
    </Box>
  );
});

export default PieGroupChart;